{
  "rabbit-selected": {
    "path": "assets/catalog/rabbit-selected.png",
    "caption": "Seated rabbit in the real landscape, resident 1 at t16. Current selected asset; calibrated pre-freeze view.",
    "sha256": "43d628fd39453d7acd811f4a44f784ddd3623c92ba7b8eadc428eb32cd6cde7f",
    "assetSha256": "9fd0696bfe045b71e9ead9af84cf910ccf495ebb8f6047690bbcd2338f3ff1e2"
  },
  "deer-selected": {
    "path": "assets/catalog/deer-selected.png",
    "caption": "Doe in a diagonal trot approaching a stop, resident 0 at t55. Exact published 534 scene.",
    "sha256": "8dc9da291cc5c12040fe97bfcafe0bdbb4269f0432230ddbb40e3a54a7b21b7b",
    "assetSha256": "ce7d01cf01af899472354c6de36dceee60a163b8d5863e33871460a5df8714c4"
  },
  "robin-selected": {
    "path": "assets/catalog/robin-selected.png",
    "caption": "Photo-guided European robin on a continuing twig, resident 15 at t23. Exact selected full10 asset in the real landscape; grip wrapping remains provisional.",
    "sha256": "16912b906b0e64f90f43a83027168a59f9011b60fb39e39f7b52db07ec793a47",
    "assetSha256": "54607a09f39df438c4faf706cacf9808a936efbc6b7ffda9008335a14f906053"
  },
  "dragonfly-selected": {
    "path": "assets/catalog/dragonfly-selected.png",
    "caption": "Current dragonfly hovering, resident 9 at t4. Exact published 534 scene; simplified body and wing anatomy remains under review.",
    "sha256": "169511f1e3d30928c03353014301238bae29195fb309297a9a8b27bc29cb8e07",
    "assetSha256": "246405dd1a2ba293337a56866e3b9103e00b829102ec839f93a255c5d45682f9"
  },
  "firefly-selected": {
    "path": "assets/catalog/firefly-selected.png",
    "caption": "Male firefly during a yellow ventral flash, resident 0 at t9. Exact selected compact04 asset in the real landscape; corrected-hinge pilot view.",
    "sha256": "056100449a6038b9b39f3cb935f87296ba732103d56b5f54ad2842bf35d6fff0",
    "assetSha256": "fc262859531598c1daeccd4fc8a0a00c3862a99fea31d7dd3848e68589cf07d5"
  },
  "fish-selected": {
    "path": "assets/catalog/fish-selected.png",
    "caption": "Current carp swimming underwater, resident 0 at t5. Exact published 534 scene; water reduces the contrast in this actual landscape view.",
    "sha256": "724e0670fd5b6dd65fed5eb7869ee1efc196bdb98b548743895db9bffaf77cf4",
    "assetSha256": "ae16fd0a1a14723513deb35b529174973934247a8b8dd5ef842b9c0dff2dfde6"
  },
  "butterfly-monarch": {
    "path": "assets/catalog/butterfly-monarch.png",
    "caption": "Current monarch study hovering, resident 0 at t12. Exact published 534 scene; species details and common motion remain under review.",
    "sha256": "98c39ab3c185fd0b2f773b299e05fb2ae2832becf723fa0aa8cedd06e851fb54",
    "assetSha256": "89edfe272582616ada80c2438299844f4337fd143914f234e0ca5d9f74be0fb4"
  },
  "butterfly-common-blue": {
    "path": "assets/catalog/butterfly-common-blue.png",
    "caption": "Current common blue study hovering, resident 1 at t10. Exact published 534 scene; species details and common motion remain under review.",
    "sha256": "bffd92646a0d2558060117c87634a64e7503833bdd585908495377b6c5724320",
    "assetSha256": "444568e22dd87ca97af0c31b438d6af2cef2ed496e1388e9400850746ebc4be4"
  },
  "butterfly-cabbage-white": {
    "path": "assets/catalog/butterfly-cabbage-white.png",
    "caption": "Current cabbage white study hovering, resident 2 at t10. Exact published 534 scene; species details and common motion remain under review.",
    "sha256": "a042b39067aefc1e855a187b720473da754f6d183e0a30be4ed548d010ea8875",
    "assetSha256": "60fdc8d723c4325a09226660eccd4a11b41f57f0021a8ea83061d99a505541d9"
  }
}
